import React from 'react';
import { AlertCircle, RefreshCw, FileText, X } from 'lucide-react';
interface ScanErrorModalProps {
  errorType: 'camera' | 'network' | 'timeout' | 'processing';
  onRetry: () => void;
  onManualEntry: () => void;
  onClose: () => void;
}
const ERROR_MESSAGES = {
  camera: {
    title: 'Camera Connection Lost',
    message: 'Unable to connect to tray camera. Check camera power and connections.',
    action: 'Reconnect Camera'
  },
  network: {
    title: 'Network Error',
    message: 'Unable to reach detection service. Check network connection.',
    action: 'Retry Connection'
  },
  timeout: {
    title: 'Scan Timeout',
    message: 'Scan took longer than expected (>30 seconds). The system may be overloaded.',
    action: 'Try Again'
  },
  processing: {
    title: 'Processing Error',
    message: 'AI detection service encountered an error. Results may be incomplete.',
    action: 'Retry Scan'
  }
};
export function ScanErrorModal({
  errorType,
  onRetry,
  onManualEntry,
  onClose
}: ScanErrorModalProps) {
  const error = ERROR_MESSAGES[errorType];
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4" data-id="element-327">
      <div className="w-full max-w-xl bg-surface border-2 border-critical/50 rounded-modal shadow-2xl overflow-hidden" data-id="element-328">
        <div className="bg-critical/10 border-b border-critical/30 p-8 text-center" data-id="element-329">
          <div className="inline-flex p-4 bg-critical rounded-card shadow-lg mb-4" data-id="element-330">
            <AlertCircle className="w-10 h-10 text-white" data-id="element-331" />
          </div>
          <h2 className="text-2xl font-bold text-text-primary mb-2" data-id="element-332">
            {error.title}
          </h2>
          <p className="text-text-secondary" data-id="element-333">{error.message}</p>
        </div>

        <div className="p-8" data-id="element-334">
          <div className="space-y-3" data-id="element-335">
            <button onClick={onRetry} className="w-full h-14 bg-info hover:bg-blue-500 text-white rounded-input font-bold text-lg transition-all flex items-center justify-center gap-3" data-id="element-336">
              <RefreshCw className="w-5 h-5" data-id="element-337" />
              {error.action}
            </button>
            <button onClick={onManualEntry} className="w-full h-14 bg-surface-2 hover:bg-surface text-text-primary border border-border rounded-input font-bold text-base transition-all flex items-center justify-center gap-3" data-id="element-338">
              <FileText className="w-5 h-5" data-id="element-339" />
              Manual Entry Mode
            </button>
            <button onClick={onClose} className="w-full h-12 border border-border text-text-secondary hover:text-text-primary hover:border-text-secondary rounded-input font-bold transition-colors" data-id="element-340">
              Cancel
            </button>
          </div>

          <div className="mt-6 p-3 bg-info/5 border border-info/30 rounded-input" data-id="element-341">
            <p className="text-xs text-text-secondary" data-id="element-342">
              <strong data-id="element-343">Need help?</strong> Contact IT support at ext. 5500 or use
              the "Report Issue" button in Settings.
            </p>
          </div>
        </div>
      </div>
    </div>;
}